import Qs from 'qs';
import axios from 'axios';
import wx from 'weixin-js-sdk';

const apiBaseUrl = 'https://api.jiaxunyouneng.com/passport';
const USER_UNIQUE_ID = 'a0e9673552ff8f05bd0ba4af1a1db797';

export function wechat ({title, desc, link, imgUrl, type, dataUrl} = {}) {
    let params = {};
    params.user_unique_id = USER_UNIQUE_ID;
    params.url = link;

    const data = Qs.stringify(params);
    axios({
        url: apiBaseUrl + '/wechat/getSignature',
        method: 'post',
        data: data
    }).then(response => {
        const { data } = response;
        // 接口入住权限验证配置
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ]
        });

        wx.ready(function () {
            wx.updateAppMessageShareData({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                type: type, // 分享类型,music、video或link，不填默认为link
                dataUrl: dataUrl, // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            wx.updateTimelineShareData({
                title: title, // 分享标题
                link: link,
                imgUrl: imgUrl, // 分享图标
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        });
    });
}